import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import type { ModuleStatesDeclaration } from 'types/StateDeclaration';
import { NotFoundComponent } from './containers/not-found.component';

const routes: ModuleStatesDeclaration = {
  states: [
    {
      name: 'not-found',
      url: '/not-found',
      component: NotFoundComponent,
      data: {
        bodyClass: 'app-white'
      }
    }
  ]
};

@NgModule({
  imports: [UIRouterModule.forChild(routes)]
})
export class NotFoundRoutingModule {}
